module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "box box-primary",
    attrs: {
      "id": "analise"
    }
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "color": "#048019"
    }
  }, [_vm._v("Análise da Proposta")])], 1), (_vm.analise.ds_codigo_projeto_erp) ? _c('span', {
    staticStyle: {
      "color": "#a8a8a8"
    }
  }, [_vm._v(" -  N°Projeto: "), _c('b', [_vm._v(_vm._s(_vm.analise.ds_codigo_projeto_erp))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.ehSimplificada) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n      Proposta Simplificada\n    ")]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [(_vm._.isNull(_vm.analise.fep) || _vm._.isUndefined(_vm.analise.fep) || _vm._.isEmpty(_vm.analise.fep) || _vm.analise.fep === '') ? _c('div', [_c('span', {
    staticClass: "mensagem naoPreenchido"
  }, [_vm._v("FEP ainda não gerada no sistema. É necessário informar o número da FEP")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numeroFepInformado),
      expression: "numeroFepInformado"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Qual vai ser o número da FEP?",
      "min": "0",
      "max": "999",
      "step": "1"
    },
    domProps: {
      "value": (_vm.numeroFepInformado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numeroFepInformado = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.resultadoVerificacaoFepExistente))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "disabled": _vm._.isNull(_vm.numeroFepInformado) || _vm._.isEmpty(_vm.numeroFepInformado) || (+_vm.numeroFepInformado < 1 || +_vm.numeroFepInformado > 999),
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.criaNovaFep(_vm.numeroFepInformado)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Gerar FEP")])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE',
      "id": "fep"
    }
  }, [(!_vm._.isNull(_vm.analise) && !_vm._.isEmpty(_vm.analise)) ? _c('fep', {
    attrs: {
      "propsAnalise": _vm.propsAnalise
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('fieldset', [_c('odsMarcacao', {
    attrs: {
      "proposta": this.$route.params.id,
      "telaProjeto": false,
      "id": "odsMarcacao"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('licenciamentoAmbientalAnalise', {
    ref: "licenciamentoAnalise",
    attrs: {
      "idProposta": this.$route.params.id,
      "novaCarga": _vm.novaCarga
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true,
      "id": "relatorioAnalise"
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('legend', {
    attrs: {
      "disabled": false
    }
  }, [(_vm.analise.ds_fase === 'ANALISE') ? _c('fieldset', [_c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'relatorio-analise',
        params: {
          id: _vm.analise.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Preencher Relatório")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-success btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'visualiza-relatorio-analise',
        params: {
          id: _vm.analise.id,
          projeto: _vm.analise.ds_codigo_projeto_erp
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Visualizar Relatório")])], 1) : _c('fieldset', [_c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'relatorio-analise',
        params: {
          id: _vm.analise.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Visualizar Relatório")])], 1)])]), _vm._v(" "), (_vm._.isNull(_vm.analise.relatorio_analise)) ? _c('span', {
    staticClass: "mensagem naoPreenchido"
  }, [_vm._v(" Relatório da Análise não preenchido ainda")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.showModal) ? _c('div', {
    attrs: {
      "id": "modal4"
    }
  }, [_c('transition', {
    attrs: {
      "name": "modal",
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "id": "modal3"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper",
    attrs: {
      "id": "modal1"
    },
    on: {
      "click": function($event) {
        return _vm.$emit(_vm.showModal = true)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "id": "modal2"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Relatório da Análise")])]), _vm._v(" "), _c('relatorio-analise', {
    attrs: {
      "propsProposta": _vm.analise
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('b-button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    attrs: {
      "type": "button",
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Salvar ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-warning btn-sm btn-flat",
    attrs: {
      "type": "button",
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Fechar ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('br')])], 1)])])])])], 1) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.ehSimplificada) ? _c('div', {
    staticClass: "box box-widget",
    attrs: {
      "id": "ratingEntidade"
    }
  }, [_c('div', {
    staticClass: " with-border"
  }, [_vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.analise.ds_fase === 'ANALISE') ? _c('fieldset', [(!_vm.ehSimplificada) ? _c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'relatorio-rating',
        params: {
          id: _vm.analise.id
        },
        query: {
          entidade: _vm.analise.entidade.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Calcular o Rating da Entidade")]) : _vm._e()], 1) : _c('fieldset', [(!_vm.ehSimplificada) ? _c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'relatorio-rating',
        params: {
          id: _vm.analise.id
        },
        query: {
          entidade: _vm.analise.entidade.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Visualizar o Rating da Entidade")]) : _vm._e()], 1)]), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.analise.ds_fase !== 'CADASTRO') ? _c('questionario-riscos', {
    key: _vm.questRiscKey,
    ref: "child",
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE',
      "propsAnalise": _vm.propsAnalise,
      "ehSimplificada": _vm.ehSimplificada,
      "id": "questionarioRiscos"
    },
    on: {
      "questionario": function($event) {
        _vm.analise.questionario_respostas = (Array.isArray($event) && $event.length === 0) ? {} : $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.analise) ? _c('categorizadores', {
    attrs: {
      "propsAnalise": _vm.propsAnalise,
      "indicativoAvaliacao": _vm.indicativoAvaliacao,
      "ehSimplificada": _vm.ehSimplificada
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.analise.edital === null) ? _c('span', [(!_vm.ehSimplificada) ? _c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE'
    }
  }, [_c('questoesAvaliacaoProjeto', {
    ref: "questoesAvaliacao",
    attrs: {
      "idProposta": _vm.analise.id,
      "resultadoAprovacao": _vm.propsAnalise.resultadoAprovacao,
      "proximaEtapa": _vm.propsAnalise.proximaEtapa
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE'
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Indicadores de Resultado")]), _vm._v(" "), _c('checklist-indicadores', {
    attrs: {
      "opcoes": _vm.opcoesIndicadores,
      "disabled": _vm.bloqueia === true
    },
    model: {
      value: (_vm.analise.dados.indicadores_resultado),
      callback: function($$v) {
        _vm.$set(_vm.analise.dados, "indicadores_resultado", $$v)
      },
      expression: "analise.dados.indicadores_resultado"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('acoes')
    },
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "acoes"
    }
  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.ds_acoes_comunicacao),
      expression: "analise.ds_acoes_comunicacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-height": "150px",
      "resize": "vertical"
    },
    attrs: {
      "placeholder": "Informe as acões de comunicação",
      "data-vv-as": "Ações",
      "name": "acoes",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.analise.ds_acoes_comunicacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise, "ds_acoes_comunicacao", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('acoes')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('acoes')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true,
      "id": "periodicidadeRelatorio"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first('periodicidade')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Periodicidade da apresentação dos relatórios de execução")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.ds_periodicidade_formulario),
      expression: "analise.ds_periodicidade_formulario"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "periodicidade",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.analise, "ds_periodicidade_formulario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.reportPeriodicity), function(i) {
    return _c('option', {
      domProps: {
        "value": i.id
      }
    }, [_vm._v(_vm._s(i.name))])
  }), 0), _vm._v(" "), (_vm.errors.first('periodicidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodicidade')))]) : _vm._e()])])])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true,
      "id": "camposEstrategicos"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Temática do Projeto")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "margin-top": "6px"
    }
  }, _vm._l((_vm.tematicaProjetoOpcoes), function(item, idx) {
    return _c('div', {
      key: idx,
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "3px 15px"
      }
    }, [_c('label', {
      staticClass: "new-control new-control-checkbox",
      staticStyle: {
        "padding-top": "4px",
        "font-weight": "normal",
        "cursor": "pointer"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.analise.dados.tematica_projeto),
        expression: "analise.dados.tematica_projeto"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.analise.dados.tematica_projeto) ? _vm._i(_vm.analise.dados.tematica_projeto, item) > -1 : (_vm.analise.dados.tematica_projeto)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.analise.dados.tematica_projeto,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.analise.dados, "tematica_projeto", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.analise.dados, "tematica_projeto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.analise.dados, "tematica_projeto", $$c)
          }
        }
      }
    }), _vm._v("\n                   " + _vm._s(item) + "\n                  "), _c('div', {
      staticClass: "new-control-indicator"
    })])])
  }), 0), _vm._v(" "), (_vm.tematicaOutrosSelecionado) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "margin-top": "6px"
    }
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dados.tematica_projeto_outros),
      expression: "analise.dados.tematica_projeto_outros"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "255",
      "placeholder": "Descreva a(s) outra(s) temática(s)"
    },
    domProps: {
      "value": (_vm.analise.dados.tematica_projeto_outros)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise.dados, "tematica_projeto_outros", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#a8a8a8",
      "font-size": "13px"
    }
  }, [_vm._v("Preenchimento obrigatório para concluir a análise.")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Ação Estratégica")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "margin-top": "6px"
    }
  }, _vm._l((_vm.direcionadoresEstrategicosOpcoes), function(item, idx) {
    return _c('div', {
      key: idx,
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "3px 15px"
      }
    }, [_c('label', {
      staticClass: "new-control new-control-checkbox",
      staticStyle: {
        "padding-top": "4px",
        "font-weight": "normal"
      },
      style: ({
        cursor: _vm.ehDirecionadorAutomatico(item) ? 'not-allowed' : 'pointer'
      })
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.analise.dados.direcionadores_estrategicos),
        expression: "analise.dados.direcionadores_estrategicos"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.ehDirecionadorAutomatico(item)
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.analise.dados.direcionadores_estrategicos) ? _vm._i(_vm.analise.dados.direcionadores_estrategicos, item) > -1 : (_vm.analise.dados.direcionadores_estrategicos)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.analise.dados.direcionadores_estrategicos,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.analise.dados, "direcionadores_estrategicos", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.analise.dados, "direcionadores_estrategicos", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.analise.dados, "direcionadores_estrategicos", $$c)
          }
        }
      }
    }), _vm._v("\n                   " + _vm._s(item) + "\n                  "), _c('div', {
      staticClass: "new-control-indicator"
    })]), _vm._v(" "), (_vm.textoAjudaDirecionador(item)) ? _c('span', {
      staticClass: "ajuda-direcionador",
      class: {
        'ajuda-direcionador-esquerda': (idx % 3) === 2
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ajuda-direcionador-texto"
    }, [_vm._v(_vm._s(_vm.textoAjudaDirecionador(item)))])]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Comunicadores Populares")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('label', {
    staticClass: "new-control new-control-checkbox",
    staticStyle: {
      "padding-top": "4px",
      "font-weight": "normal",
      "cursor": "pointer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dados.comunicadores_populares),
      expression: "analise.dados.comunicadores_populares"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.analise.dados.comunicadores_populares) ? _vm._i(_vm.analise.dados.comunicadores_populares, null) > -1 : (_vm.analise.dados.comunicadores_populares)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.analise.dados.comunicadores_populares,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.analise.dados, "comunicadores_populares", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.analise.dados, "comunicadores_populares", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.analise.dados, "comunicadores_populares", $$c)
        }
      }
    }
  }), _vm._v("\n                 O projeto possui Comunicadores Populares\n                "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Histórico da Proponente")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dados.historico_proponente),
      expression: "analise.dados.historico_proponente"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-height": "150px",
      "resize": "vertical"
    },
    attrs: {
      "rows": "6",
      "placeholder": _vm.placeholderHistoricoProponente
    },
    domProps: {
      "value": (_vm.analise.dados.historico_proponente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise.dados, "historico_proponente", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Perfil Territorial")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dados.perfil_territorial),
      expression: "analise.dados.perfil_territorial"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-height": "150px",
      "resize": "vertical"
    },
    attrs: {
      "rows": "6",
      "placeholder": "Informações sobre o território, dados sobre a atuação da entidade e se já atua em rede"
    },
    domProps: {
      "value": (_vm.analise.dados.perfil_territorial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise.dados, "perfil_territorial", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Objeto do Convênio")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dados.objeto_convenio),
      expression: "analise.dados.objeto_convenio"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-height": "150px",
      "resize": "vertical"
    },
    attrs: {
      "rows": "6",
      "placeholder": "Descreva o objeto do convênio"
    },
    domProps: {
      "value": (_vm.analise.dados.objeto_convenio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise.dados, "objeto_convenio", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Dirigente Indígena ou Quilombola")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('label', {
    staticClass: "new-control new-control-checkbox",
    staticStyle: {
      "padding-top": "4px",
      "font-weight": "normal",
      "cursor": "pointer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dados.dirigente_indigena_quilombola),
      expression: "analise.dados.dirigente_indigena_quilombola"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.analise.dados.dirigente_indigena_quilombola) ? _vm._i(_vm.analise.dados.dirigente_indigena_quilombola, null) > -1 : (_vm.analise.dados.dirigente_indigena_quilombola)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.analise.dados.dirigente_indigena_quilombola,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.analise.dados, "dirigente_indigena_quilombola", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.analise.dados, "dirigente_indigena_quilombola", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.analise.dados, "dirigente_indigena_quilombola", $$c)
        }
      }
    }
  }), _vm._v("\n                 A entidade possui dirigente indígena ou quilombola\n                "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Povos Indígenas abrangidos")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.povosIndigenasOpcoes,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "searchable": true,
      "taggable": true,
      "tag-placeholder": "Pressione enter para adicionar este povo",
      "disabled": _vm.bloqueia === true,
      "placeholder": "Busque e selecione os povos indígenas abrangidos (se houver)",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado"
    },
    on: {
      "tag": _vm.adicionaPovoIndigena
    },
    model: {
      value: (_vm.analise.dados.povos_indigenas),
      callback: function($$v) {
        _vm.$set(_vm.analise.dados, "povos_indigenas", $$v)
      },
      expression: "analise.dados.povos_indigenas"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Nenhum povo localizado. Digite e pressione enter para adicionar.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("Nenhum povo cadastrado. Digite e pressione enter para adicionar.")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#a8a8a8",
      "font-size": "13px"
    }
  }, [_vm._v("Deixe em branco caso o projeto não abranja povos indígenas.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Povos Quilombolas abrangidos")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.povosQuilombolasOpcoes,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "searchable": true,
      "taggable": true,
      "tag-placeholder": "Pressione enter para adicionar este povo",
      "disabled": _vm.bloqueia === true,
      "placeholder": "Busque e selecione os povos quilombolas abrangidos (se houver)",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado"
    },
    on: {
      "tag": _vm.adicionaPovoQuilombola
    },
    model: {
      value: (_vm.analise.dados.povos_quilombolas),
      callback: function($$v) {
        _vm.$set(_vm.analise.dados, "povos_quilombolas", $$v)
      },
      expression: "analise.dados.povos_quilombolas"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Nenhum povo localizado. Digite e pressione enter para adicionar.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("Nenhum povo cadastrado. Digite e pressione enter para adicionar.")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#a8a8a8",
      "font-size": "13px"
    }
  }, [_vm._v("Deixe em branco caso o projeto não abranja povos quilombolas.")])], 1)]), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "id": "contextoTerritorial"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "margin-bottom": "6px"
    }
  }, [_vm._v("I) Características Geográficas")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, _vm._l((_vm.caracteristicasGeograficasOpcoes), function(item, idx) {
    return _c('div', {
      key: idx,
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "3px 15px"
      }
    }, [_c('label', {
      staticClass: "new-control new-control-checkbox",
      staticStyle: {
        "padding-top": "4px",
        "font-weight": "normal",
        "cursor": "pointer"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.analise.dados.contexto_caracteristicas_geograficas),
        expression: "analise.dados.contexto_caracteristicas_geograficas"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.analise.dados.contexto_caracteristicas_geograficas) ? _vm._i(_vm.analise.dados.contexto_caracteristicas_geograficas, item) > -1 : (_vm.analise.dados.contexto_caracteristicas_geograficas)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.analise.dados.contexto_caracteristicas_geograficas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.analise.dados, "contexto_caracteristicas_geograficas", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.analise.dados, "contexto_caracteristicas_geograficas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.analise.dados, "contexto_caracteristicas_geograficas", $$c)
          }
        }
      }
    }), _vm._v("\n                     " + _vm._s(item) + "\n                    "), _c('div', {
      staticClass: "new-control-indicator"
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "margin-top": "12px",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "margin-bottom": "6px"
    }
  }, [_vm._v("II) Biomas")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, _vm._l((_vm.biomasOpcoes), function(item, idx) {
    return _c('div', {
      key: idx,
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "3px 15px"
      }
    }, [_c('label', {
      staticClass: "new-control new-control-checkbox",
      staticStyle: {
        "padding-top": "4px",
        "font-weight": "normal",
        "cursor": "pointer"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.analise.dados.contexto_biomas),
        expression: "analise.dados.contexto_biomas"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.analise.dados.contexto_biomas) ? _vm._i(_vm.analise.dados.contexto_biomas, item) > -1 : (_vm.analise.dados.contexto_biomas)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.analise.dados.contexto_biomas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.analise.dados, "contexto_biomas", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.analise.dados, "contexto_biomas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.analise.dados, "contexto_biomas", $$c)
          }
        }
      }
    }), _vm._v("\n                     " + _vm._s(item) + "\n                    "), _c('div', {
      staticClass: "new-control-indicator"
    })])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true,
      "id": "analiseDetalhada"
    }
  }, [(!_vm.ehSimplificadaRelatorio) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Situação Problema")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dados.situacao_problema),
      expression: "analise.dados.situacao_problema"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-height": "200px",
      "resize": "vertical"
    },
    attrs: {
      "rows": "10",
      "placeholder": "Descreva a situação problema que o projeto pretende enfrentar"
    },
    domProps: {
      "value": (_vm.analise.dados.situacao_problema)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise.dados, "situacao_problema", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Proposta de Solução e Sustentabilidade")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dados.analise),
      expression: "analise.dados.analise"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-height": "200px",
      "resize": "vertical"
    },
    attrs: {
      "rows": "10",
      "placeholder": _vm.placeholderAnalise
    },
    domProps: {
      "value": (_vm.analise.dados.analise)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise.dados, "analise", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "space-between",
      "gap": "8px",
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Distribuição e Informações dos Recursos")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "confirm",
      rawName: "v-confirm",
      value: ({
        ok: function (retorno) { return _vm.geraAnaliseTecnica(); },
        cancel: function () {},
        message: 'O texto atual da <b>Distribuição e Informações dos Recursos</b> será substituído pela lista de atividades e valores. Deseja continuar?'
      }),
      expression: "{ok: retorno => geraAnaliseTecnica(), cancel: () => {}, message: 'O texto atual da <b>Distribuição e Informações dos Recursos</b> será substituído pela lista de atividades e valores. Deseja continuar?'}"
    }],
    staticClass: "btn btn-default btn-sm btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Gerar novamente\n              ")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dados.analise_tecnica),
      expression: "analise.dados.analise_tecnica"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-height": "200px",
      "resize": "vertical"
    },
    attrs: {
      "rows": "10",
      "placeholder": "Descreva a distribuição dos recursos por atividade e as informações relevantes"
    },
    domProps: {
      "value": (_vm.analise.dados.analise_tecnica)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise.dados, "analise_tecnica", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "id": "checklistAnalise"
    }
  }, [_vm._m(6), _vm._v(" "), _c('checklist-analise', {
    attrs: {
      "dados": _vm.analise.dados,
      "disabled": _vm.bloqueia === true
    }
  }, [(_vm.restricoesEntidade) ? _c('template', {
    slot: "inicio-regularidade"
  }, [_c('quadro-restricoes-entidade', {
    attrs: {
      "restricoes": _vm.restricoesEntidade
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "antes-enquadramento"
  }, [_c('fieldset', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Parecer jurídico")])]), _vm._v(" "), _c('parecer-juridico-campos', {
    attrs: {
      "analise": _vm.analise
    }
  })], 1)])], 2)], 1), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('fieldset', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "id": "pontosAtencaoMitigadores"
    }
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._l((_vm.analise.dados.pontos_atencao_mitigadores), function(item, idx) {
    return _c('div', {
      key: idx,
      staticStyle: {
        "display": "flex",
        "gap": "16px",
        "align-items": "flex-start",
        "margin-bottom": "8px"
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.risco),
        expression: "item.risco"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Descreva o ponto de atenção",
        "maxlength": "255"
      },
      domProps: {
        "value": (item.risco)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "risco", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.mitigador),
        expression: "item.mitigador"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Descreva o elemento mitigador",
        "maxlength": "255"
      },
      domProps: {
        "value": (item.mitigador)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "mitigador", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "52px",
        "flex": "none"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger btn-sm btn-flat",
      attrs: {
        "type": "button",
        "disabled": _vm.analise.dados.pontos_atencao_mitigadores.length === 1
      },
      on: {
        "click": function($event) {
          return _vm.removeRiscoMitigador(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addRiscoMitigador()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar Ponto de Atenção/Mitigador\n            ")])])], 2) : _vm._e(), _vm._v(" "), (!_vm.ehSimplificadaRelatorio) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Condicionantes")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "120px",
      "resize": "none"
    },
    attrs: {
      "name": "condicionantes",
      "placeholder": "Informe os requisitos que devem ser cumpridos antes da execução do projeto"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.analise.dados.condicionantes),
      callback: function($$v) {
        _vm.$set(_vm.analise.dados, "condicionantes", $$v)
      },
      expression: "analise.dados.condicionantes"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "12px",
      "margin-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Proposta")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-height": "80px",
      "resize": "none"
    },
    attrs: {
      "name": "propostaTexto"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.analise.dados.conclusao_analise),
      callback: function($$v) {
        _vm.$set(_vm.analise.dados, "conclusao_analise", $$v)
      },
      expression: "analise.dados.conclusao_analise"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "novoRelatorioAnalise"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "8px 0"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.abreLaravelAutenticado('/sgp/propostas/' + _vm.$route.params.id + '/relatorio')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Visualizar Novo Relatório de Análise\n            ")])])])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true,
      "id": "documentosAnalise"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.documentosAnalise,
      "propsEtapa": _vm.analise.ds_fase,
      "documentTypes": _vm.dctos,
      "documentosObrigatorios": '',
      "local-uso": 'TODOS'
    }
  })], 1)])]), _vm._v(" "), (_vm.analise.ds_fase === 'ANALISE') ? _c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('resultadoAprovacao')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Decisões")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.resultadoAprovacao),
      expression: "analise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "ENCAMINHAR_DEFERIMENTO"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.resultadoAprovacao, "ENCAMINHAR_DEFERIMENTO")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.analise, "resultadoAprovacao", "ENCAMINHAR_DEFERIMENTO")
      }, function($event) {
        return _vm.limparInfo()
      }]
    }
  }), _vm._v(" Encaminhar para deferimento\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.resultadoAprovacao),
      expression: "analise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "DEVOLVER_ENTIDADE"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.resultadoAprovacao, "DEVOLVER_ENTIDADE")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.analise, "resultadoAprovacao", "DEVOLVER_ENTIDADE")
      }
    }
  }), _vm._v(" Devolver à entidade para ajustes\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.resultadoAprovacao),
      expression: "analise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "INCLUIR_SAPIENS"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.resultadoAprovacao, "INCLUIR_SAPIENS")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.analise, "resultadoAprovacao", "INCLUIR_SAPIENS")
      }
    }
  }), _vm._v(" Criar projeto e retornar para análise\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.resultadoAprovacao),
      expression: "analise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "ENVIAR_PENDENCIAS"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.resultadoAprovacao, "ENVIAR_PENDENCIAS")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.analise, "resultadoAprovacao", "ENVIAR_PENDENCIAS")
      }
    }
  }), _vm._v(" Enviar para pendências\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.resultadoAprovacao),
      expression: "analise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "ANULAR_PROPOSTA"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.resultadoAprovacao, "ANULAR_PROPOSTA")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.analise, "resultadoAprovacao", "ANULAR_PROPOSTA")
      }
    }
  }), _vm._v(" Anular proposta\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]), _vm._v(" "), (_vm.errors.first('resultadoAprovacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('É necessário preencher uma decisão da Análise!')))]) : _vm._e(), _vm._v(" "), (_vm.analise.resultadoAprovacao === 'ENVIAR_PENDENCIAS') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Motivo da pendência")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "justificativa"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.analise.observacao),
      callback: function($$v) {
        _vm.$set(_vm.analise, "observacao", $$v)
      },
      expression: "analise.observacao"
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.analise.resultadoAprovacao === 'DEVOLVER_ENTIDADE') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Motivo da pendência")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "justificativa"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.analise.observacao),
      callback: function($$v) {
        _vm.$set(_vm.analise, "observacao", $$v)
      },
      expression: "analise.observacao"
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.analise.resultadoAprovacao === 'ANULAR_PROPOSTA') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Justificativa para reprovação")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "justificativa"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.analise.observacao),
      callback: function($$v) {
        _vm.$set(_vm.analise, "observacao", $$v)
      },
      expression: "analise.observacao"
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()], 1)]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#fcfcfc"
    }
  }, [_c('legend', [_vm._v(" Relatório da Análise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-horizontal",
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', {
    staticClass: "box-title"
  }, [_vm._v(" Rating da Entidade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Periodicidade da apresentação dos relatórios de execução")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Informações Estratégicas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC",
      "margin-top": "10px"
    }
  }, [_c('legend', [_vm._v(" Priorização de Público")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Contexto Territorial")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Checklist da Análise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Pontos de Atenção e Elementos Mitigadores")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "gap": "16px",
      "margin-bottom": "6px"
    }
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "flex": "1",
      "margin": "0",
      "text-align": "left"
    }
  }, [_vm._v("Ponto de Atenção")]), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    staticStyle: {
      "flex": "1",
      "margin": "0",
      "text-align": "left"
    }
  }, [_vm._v("Elemento Mitigador")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "52px",
      "flex": "none"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Documentos da Análise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Decisões da análise da proposta")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-584c69a9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/proposta/analise.vue
// module id = 1969
// module chunks = 1